import { contactPageData } from "../data";
export default {
    name: 'contactUs',
    title: 'Contact Us Page',
    type: 'document',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'string',
            initialValue: contactPageData.title
        },
        {
            name: 'address',
            title: 'Address',
            type: 'object',
            initialValue: contactPageData.address,
            fields: [
                {
                    name: 'street',
                    title: 'Street',
                    type: 'string'
                },
                {
                    name: 'city',
                    title: 'City',
                    type: 'string'
                },
                {
                    name: 'province',
                    title: 'Province',
                    type: 'string'
                },
                {
                    name: 'postalCode',
                    title: 'Postal Code',
                    type: 'string'
                },
                {
                    name: 'country',
                    title: 'Country',
                    type: 'string'
                }
            ]
        },
        {
            name: 'contactInfo',
            title: 'Contact Information',
            type: 'object',
            initialValue: contactPageData.contactInfo,
            fields: [
                {
                    name: 'phone',
                    title: 'Phone',
                    type: 'string'
                },
                {
                    name: 'email',
                    title: 'Email',
                    type: 'string'
                }
            ]
        },
        {
            name: 'mapEmbed',
            title: 'Map Embed Code',
            type: 'text',
            initialValue: contactPageData.mapEmbed
        }
    ],
    preview: {
        select: {
            title: 'title',
            address: 'address',
        },
        prepare({ title, address }) {
            return {
                title: title,
                subtitle: `${address.street}, ${address.city}, ${address.province} ${address.postalCode}, ${address.country}`,
            }
        }
    }
} 